import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// --- Main Website Components ---
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TrustBadges from './components/TrustBadges';
import Calculator from './components/Calculator';
import VideoSection from './components/VideoSection';
import About from './components/About';
import Services from './components/Services';
import Benefits from './components/Benefits';
import Statistics from './components/Statistics';
import EnvironmentalImpact from './components/EnvironmentalImpact';
import PMSuryaghar from './components/PMSuryaghar';
import NetMetering from './components/NetMetering';
import HowItWorks from './components/HowItWorks';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Gallery from './components/Gallery';
import Newsletter from './components/Newsletter';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import ChatBot from './components/ChatBot';
import BackToTop from './components/BackToTop';

// --- Styles ---
import './main.css';

// --- Admin Components ---
import AdminLogin from './components/admin/AdminLogin';
import AdminLayout from './components/admin/AdminLayout';     // NEW: Sidebar Layout
import DashboardHome from './components/admin/DashboardHome'; // NEW: Stats Page
import AdminSettings from './components/admin/AdminSettings';
import AdminGallery from './components/admin/AdminGallery';
import AdminCalculatorRates from './components/admin/AdminCalculatorRates';
import AdminHeroSettings from './components/admin/AdminHeroSettings';
import AdminVideoSettings from './components/admin/AdminVideoSettings';
import AdminAboutSettings from './components/admin/AdminAboutSettings';
import AdminServices from './components/admin/AdminServices';
import AdminBenefits from './components/admin/AdminBenefits';
import AdminStatistics from './components/admin/AdminStatistics';
import AdminPMSuryaghar from './components/admin/AdminPMSuryaghar';
import AdminNetMetering from './components/admin/AdminNetMetering';
import AdminProcessSteps from './components/admin/AdminProcessSteps';
import AdminTestimonials from './components/admin/AdminTestimonials';
import AdminFAQ from './components/admin/AdminFAQ';
import AdminNewsletter from './components/admin/AdminNewsletter';
import AdminContact from './components/admin/AdminContact';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          
          {/* =========================================
              ROUTE 1: Main Website (Public)
              URL: http://localhost:3000/
          ========================================= */}
          <Route path="/" element={
            <>
              <Navbar />
              <Hero />
              <TrustBadges />
              <Calculator />
              <VideoSection />
              <About />
              <Services />
              <Benefits />
              <Statistics />
              <EnvironmentalImpact />
              <PMSuryaghar />
              <NetMetering />
              <HowItWorks />
              <Testimonials />
               <FAQ /> 
              <Gallery />
               <Newsletter />
              
             
             
              <Contact />
              <Footer />
              
              {/* Floating Elements */}
              <WhatsAppButton />
              <ChatBot />
              <BackToTop />
            </>
          } />

          {/* =========================================
              ROUTE 2: Admin Login
              URL: http://localhost:3000/admin/login
          ========================================= */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* =========================================
              ROUTE 3: Admin Panel (Protected Layout)
              URL: http://localhost:3000/admin/*
              
              Explanation: 'AdminLayout' sidebar hold karega, 
              aur baaki pages uske andar 'Outlet' me dikhenge.
          ========================================= */}
          <Route path="/admin" element={<AdminLayout />}>
            
           
           <Route path="dashboard" element={<DashboardHome />} />
           <Route path="hero-settings" element={<AdminHeroSettings />} />
           <Route path="video-settings" element={<AdminVideoSettings />} />
           <Route path="about-settings" element={<AdminAboutSettings />} />
           <Route path="services" element={<AdminServices />} />
           <Route path="benefits" element={<AdminBenefits />} />
           <Route path="statistics" element={<AdminStatistics />} />
          <Route path="pm-suryaghar" element={<AdminPMSuryaghar />} />
          <Route path="net-metering" element={<AdminNetMetering />} />
          <Route path="process-steps" element={<AdminProcessSteps />} />
          <Route path="testimonials" element={<AdminTestimonials />} />
          <Route path="faq" element={<AdminFAQ />} />
          <Route path="newsletter" element={<AdminNewsletter />} />
          <Route path="contact-leads" element={<AdminContact />} />



           <Route path="gallery" element={<AdminGallery />} />
           <Route path="calculator-rates" element={<AdminCalculatorRates />} />
           
           <Route path="settings" element={<AdminSettings />} />
            
          </Route>

        </Routes>
      </div>
    </Router>
  );
}

export default App;